// extracted by mini-css-extract-plugin
module.exports = {"rule-wrapper":"index_rule-wrapper_1vQO5","rule-button":"index_rule-button_QV8Q-","rule-title":"index_rule-title_3zwjs","rule-content":"index_rule-content_3isLZ"};